module.exports = __webpack_public_path__ + "static/media/expertise.131d381f.svg";